import React from "react";
import PropTypes from "prop-types";
import Typography from "../../shared/components/Typography";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(2),
  },
}));

function Heading(props: any) {
  const classes = useStyles();

  const variant: any = `h${props.level}`;
  return (
    <Typography className={classes.root} variant={variant}>
      {props.children}
    </Typography>
  );
}

Heading.propTypes = {
  children: PropTypes.any,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
};

export default Heading;
